/**
 * Dealer Directory data contract constants (Dealer Directory M2).
 */

/** Directory-facing public states (aligned with Dealer Profile page states). */
export const DEALER_DIRECTORY_PUBLIC_STATE = {
  PUBLIC: "public",
  PUBLIC_NO_INVENTORY: "public_no_inventory",
  PUBLIC_CONTACT_LIMITED: "public_contact_limited",
  HIDDEN: "hidden",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
  REJECTED: "rejected",
  DELETED: "deleted",
  UNKNOWN: "unknown",
  INVALID: "invalid",
  ERROR: "error",
};

/** States that may appear on the public directory (Dealer Directory M4). */
export const DEALER_DIRECTORY_INCLUDABLE_STATES = [
  DEALER_DIRECTORY_PUBLIC_STATE.PUBLIC,
  DEALER_DIRECTORY_PUBLIC_STATE.PUBLIC_NO_INVENTORY,
  DEALER_DIRECTORY_PUBLIC_STATE.PUBLIC_CONTACT_LIMITED,
];

/** Dev/service exclusion reason keys — never shown to buyers. */
export const DEALER_DIRECTORY_EXCLUSION_REASONS = {
  MISSING_ITEM: "missing_item",
  MISSING_DISPLAY_NAME: "missing_display_name",
  INVALID_SLUG: "invalid_slug",
  MISSING_PROFILE_HREF: "missing_profile_href",
  UNSAFE_PROFILE_LINK: "unsafe_profile_link",
  NOT_DIRECTORY_ELIGIBLE: "not_directory_eligible",
  DUPLICATE_MERGED: "duplicate_merged",
  STATE_HIDDEN: "state_hidden",
  STATE_INACTIVE: "state_inactive",
  STATE_SUSPENDED: "state_suspended",
  STATE_REJECTED: "state_rejected",
  STATE_DELETED: "state_deleted",
  STATE_UNKNOWN: "state_unknown",
  STATE_INVALID: "state_invalid",
  STATE_ERROR: "state_error",
};

export const PUBLIC_DEALER_DIRECTORY_PATH_PREFIX = "/v/automap/concesionarios";

/** Short verification labels for directory cards (not full profile copy). */
export const DEALER_DIRECTORY_VERIFICATION_LABELS_ES = {
  verified: "Verificado",
  pending: "Verificación pendiente",
  unverified: "No verificado",
  rejected: "No disponible",
  suspended: "No disponible",
  unknown: "Verificación no disponible",
};

/** Inventory count labels for directory cards. */
export const DEALER_DIRECTORY_INVENTORY_LABELS_ES = {
  unknown: "Inventario por confirmar",
  empty: "Sin vehículos disponibles",
  one: "1 vehículo disponible",
  many: (count) => `${count} vehículos disponibles`,
};

/** Contact availability labels for directory cards (no PII). */
export const DEALER_DIRECTORY_CONTACT_AVAILABILITY = {
  AVAILABLE: "available",
  PHONE_ONLY: "phone_only",
  MISSING: "missing",
  INVALID: "invalid",
  UNAVAILABLE: "unavailable",
};

export const DEALER_DIRECTORY_CONTACT_LABELS_ES = {
  available: "Contacto disponible",
  phone_only: "Teléfono disponible",
  missing: "Contacto por confirmar",
  invalid: "Contacto no disponible",
  unavailable: "No disponible",
};

/** Days since last inventory update to mark `isRecentlyUpdated`. */
export const DEALER_DIRECTORY_RECENTLY_UPDATED_DAYS = 7;

export const DEALER_DIRECTORY_SOURCE = {
  API: "api",
  PROFILE: "profile",
  LISTING_GROUP: "listing_group",
  UNKNOWN: "unknown",
};
